export default __webpack_public_path__ + "419269abdae9a25839de96e6880f7c66.svg";